export default (e, identifier) => {
  e && e.preventDefault();
  const elem = document.getElementById(identifier);
  elem && elem.scrollIntoView({ behavior: 'smooth' });
};
